import { Box, Paper } from '@mui/material';

/**A footer created from a stylized Box and Paper MUI component.
 *
 * @param {ReactNode|Array<ReactNode>} leftContent A single ReactNode or an Array of ReactNodes to display as the left-hand side content. Generally buttons.
 * @param {ReactNode|Array<ReactNode>} rightContent A single ReactNode or an Array of ReactNodes to display as the right-hand side content. Generally buttons.
 * @param {Object} leftSx A MUI sx Object to apply to the Box wrapper to override/apply additional styles than the default for the left-hand side container.
 * @param {Object} rightSx A MUI sx Object to apply to the Box wrapper to override/apply additional styles than the default for the right-hand side container.
 * @param {Object} boxSx A MUI sx Object to apply to the Box wrapper to override/apply additional styles than the default.
 * @param {Object} paperSx A MUI sx Object to apply to the Paper background to override/apply additions styles than the default.
 * @returns
 */
const MuiFooter = ({ leftContent, rightContent, leftSx, rightSx, boxSx, paperSx, ...restOfProps }) => {
    return (
        <Box
            sx={{
                position: 'fixed',
                bottom: 0,
                width: 'calc(100% - 100px)', //TODO This 100px is the size of the left hand nav, when the LHN gets refactored, this will need to be adjusted as well
                zIndex: 2,
                ...boxSx,
            }}
            {...restOfProps}
        >
            <Paper
                sx={{
                    display: 'flex',
                    gap: '1em',
                    justifyContent: 'space-between',
                    padding: '1% 9.72%',
                    ...paperSx,
                }}
            >
                <Box
                    sx={(theme) => {
                        return {
                            display: 'flex',
                            gap: theme.spacing(1),
                            ...leftSx,
                        };
                    }}
                >
                    {leftContent}
                </Box>

                <Box
                    sx={(theme) => {
                        return {
                            display: 'flex',
                            gap: theme.spacing(1),
                            ...rightSx,
                        };
                    }}
                >
                    {rightContent}
                </Box>
            </Paper>
        </Box>
    );
};

export default MuiFooter;
